import {Inject, Injectable} from '@angular/core';
import {StateService} from "@uirouter/core";
import {HttpClient} from "@angular/common/http";
import {DOCUMENT} from '@angular/common';
import * as _ from "lodash";

import {ControlService} from "./tiles";
import {DatabaseService} from "./database.service";
import {MenuService} from "./menu.service";
import {ParametersService} from "./parameters.service";
import {SubtitlesService} from "./subtitles.service";
import {UserService} from "./user.service";
import {ViewsService} from "./views.service";
import {ZonesSystemService} from "./zones-system.service";
import {
    ActuatorState,
    MenuElement, MenuType, MenuTypeKey, ModuleStatus, SelectedZoneDataType,
    SystemContainerView, ZonesData,
    ZonesParameter,
    ZoneStateView, ZoneTile,
    ZoneTileType,
    ZoneTileTypeId, ZoneTime, ZoneViewData
} from "../models";

@Injectable({
    providedIn: 'root'
})
export class ZonesService {
    parent: 0 | MenuElement | null;
    private centerHeight: number = 0;
    containerTileDropdown = {
        id: null,
        show: false,
        position: {
            bottom: '',
            top: '',
        }
    };
    controlTemplate: ZoneStateView = 'mode_select';
    currentlyOpenDropdown: ZoneTileTypeId = 0;
    noActiveZone: boolean = false;
    private previeusTemplate: ZoneStateView = 'mode_select';
    selectedContainer: SystemContainerView | null = null;
    selectedZone: SelectedZoneDataType;
    showZonesView = true;
    overflow: boolean | undefined = undefined;
    time: ZoneTime = {};
    private wrapperHeight: number = 0;
    valveDropdown = {
        opentherm: false,
        systemTileId: null,
        additionalContact: false,
        position: {
            bottom: '',
            top: '',
        },
        showDropdownInfo: false,
    };
    zonesParameter: ZonesParameter = {};

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private control: ControlService,
        private database: DatabaseService,
        private http: HttpClient,
        private menu: MenuService,
        private parameters: ParametersService,
        private $state: StateService,
        private subtitles: SubtitlesService,
        private user: UserService,
        private views: ViewsService,
        private zonesSystem: ZonesSystemService,
    ) {
    }

    checkNoActiveZones(): void {
        let activeZone = false;
        let noActiveZone = false;

        const zonesData = this.database.zones.getValue() as ZonesData;

        if (zonesData?.elements?.length > 0) {
            zonesData.elements.forEach(zone => {
                if (zone !== null) {
                    if (zone.zone.zoneState === 'noAlarm' || zone.zone.zoneState === 'noCommunication' || zone.zone.zoneState === 'sensorDamaged') {
                        this.views.zonesView.show = true;
                        activeZone = true;
                    }
                    if (zone.zone.zoneState === 'zoneUnregistered' || zone.zone.zoneState === 'zoneOff') noActiveZone = true;

                    zone.underfloorAlert = zone.underfloor.currentState === 'alarm';
                    this.checkBaterryLevel(zone);
                    this.checkSensorAlarm(zone);
                    this.checkAdditionalContactsAlarm(zone);
                }
            });

            this.database.zones.next(zonesData);
        }

        this.noActiveZone = activeZone === false && noActiveZone;
    }

    private checkBaterryLevel(zone: ZoneViewData): void {
        zone.actuators.forEach(actuator => {
            zone.actuatorAlert = zone.actuatorAlert === true
                || actuator.state !== 'noAlarm' && actuator.state !== 'waiting';
        })
    }

    private checkSensorAlarm(zone: ZoneViewData): void {
        zone.windowsSensors.forEach(sensor => {
            zone.windowSensorAlert = zone.windowSensorAlert === true
                || sensor.state !== 'noAlarm' && sensor.state !== 'waiting';
        })
    }

    private checkAdditionalContactsAlarm(zone: ZoneViewData): void {
        zone.additionalContacts.forEach(contact => {
            zone.additionalContactAlert = zone.additionalContactAlert === true
                || contact.state !== 'noAlarm' && contact.state !== 'waiting';
        })
    }

    openControl(): void{
        this.menu.getElementMenu(this.zonesParameter.menuId);
        // this.$state.go('menu', {selectedModuleHash: this.parameters.selectedModuleHash});
        this.control.setControl(this.menu.elementMenu);
    }

    setOverflow(): void{
        setTimeout(() => {
            this.wrapperHeight = this.document.querySelector(".zone-control-wrapper").getBoundingClientRect().height;
            this.centerHeight = this.document.querySelector(".center-xy").getBoundingClientRect().height;
            this.overflow = this.centerHeight - 90 < this.wrapperHeight;
        });
    }

    setTemplate(name: ZoneStateView, zone?: ZoneViewData): void {
        if (this.parameters.offline) name = 'zones';

        if (this.parameters.selectedModule.moduleStatus
            && this.parameters.selectedModule.controllerStatus) {
            this.showHideDropdownList(0);
        }
        if (zone !== undefined) {
            this.selectedZone = _.cloneDeep(zone);
        }
        if (name === 'zones') {
            this.showZonesView = true;
            this.time = {};

        } else {
            this.showZonesView = false;

            this.previeusTemplate = this.controlTemplate;
            this.controlTemplate = name;

            const zone_states: ZoneStateView[] = ['constant_temp', 'schedule_settings',
                'schedule_select', 'constant_time', 'zone_info', 'select_zones'];

            if (zone_states.indexOf(name) >= 0) {
                this.$state.go('zone_details', {selectedModuleHash: this.parameters.selectedModuleHash});
            } else {
                this.$state.go('zone', {selectedModuleHash: this.parameters.selectedModuleHash});
            }

        }
    }

    getZoneName(zoneData: SelectedZoneDataType): string {
        const zone = zoneData as ZoneViewData;

        return zone.description.name !== ''
            ? zone.description.name
            : this.subtitles.setSubtitle(1686) + ' ' + (zone.zone.index + 1);
    }

    getScheduleName(index: number, version?: string): string {
        let name = '';
        const zonesData = this.database.zones.getValue();

        if (zonesData['globalSchedules'].elements.length === 5) {

            if (index >= 0 && index < zonesData['globalSchedules'].elements.length) {

                if (zonesData['globalSchedules'].elements[index].name === 'default'
                    || zonesData['globalSchedules'].elements[index].name === '') {
                    name = version === 'long' ? this.subtitles.setSubtitle(1683) : this.subtitles.setSubtitle(3588);
                    name += ' ' + (zonesData['globalSchedules'].elements[index].index + 1);
                } else {
                    name = zonesData['globalSchedules'].elements[index].name;
                }
            }
        } else {
            name = this.subtitles.setSubtitle(3162);
        }

        return name;
    }

    goToMenu(tile: ZoneTile, submenuElementId?: number): void {
        const menuType = this.getMenuType(tile, this.menu.allElementMenu);
        const menuId = submenuElementId || tile.menuId;
        this.searchParentElement(menuId, 'element', menuType);
        let stateName: string;
        if (this.parent) {
            if (this.parent.type === 0){
                stateName = MenuTypeKey[menuType];
             }

            this.$state.go(stateName, {selectedModuleHash: this.parameters.selectedModuleHash});

            const selectedModuleStatus: ModuleStatus = {
                moduleStatus: true,
                controllerStatus: true,
            }

            this.menu.showSubmenu(this.menu.mainMenu[this.parent.menuType], selectedModuleStatus);
            this.menu.getMenuChild(this.parent);
            this.menu.getBreadcrumbs(this.parent);
        }
    }

    private getMenuType(tile: ZoneTile, menuList: MenuElement[] | {}): MenuType | null {
        if (typeof tile.menuId !== 'number') return null;
        if (!Array.isArray(menuList)) return null;
        const menu = menuList.find(m => m.id === tile.menuId);
        return menu?.menuType ?? null;
    }

    private searchParentElement(id: number, type: 'element' | 'parent', menuTile: string): void {
        if (Array.isArray(this.menu.allElementMenu)) {
            this.menu.allElementMenu.forEach((val) => {
                if (val.id === id && val.menuType === menuTile) {
                    if (type === 'element') {
                        this.searchParentElement(val.parentId, 'parent', menuTile);
                    } else {
                        this.parent = val;
                    }
                }
            });
        }
    }

    goHome = function() {
        window.history.back();
    }

    showHideDropdownList(id: ZoneTileTypeId, type?: ZoneTileType, elementId?: number): void {
        let zonePosition: DOMRect | 0 = 0;
        const windowHeight = window.innerHeight;

        this.currentlyOpenDropdown = id;

        if (id === 'valve' || id === 'opentherm' || id === 'additionalContact') {
            this.valveDropdown.position = {
                bottom: '',
                top: '',
            };

            if (id === 'valve') {
                this.valveDropdown.showDropdownInfo = !this.valveDropdown.showDropdownInfo;
                this.valveDropdown.opentherm = false;
                this.valveDropdown.additionalContact = false;
                this.currentlyOpenDropdown = this.valveDropdown.showDropdownInfo ? id : 0;

                if (type === 'systemTile') {
                    if (this.valveDropdown.systemTileId !== elementId) {
                        this.valveDropdown.showDropdownInfo = true;
                    }
                    this.valveDropdown.systemTileId = elementId;
                }
            }
            if (id === 'opentherm') {
                this.valveDropdown.opentherm = !this.valveDropdown.opentherm;
                this.valveDropdown.showDropdownInfo = false;
                this.valveDropdown.additionalContact = false;
                this.currentlyOpenDropdown = this.valveDropdown.opentherm ? id : 0;
            }

            if (id === 'additionalContact') {
                if (this.valveDropdown.systemTileId === elementId) {
                    this.valveDropdown.additionalContact = !this.valveDropdown.additionalContact;
                } else {
                    this.valveDropdown.systemTileId = elementId;
                    this.valveDropdown.additionalContact = true;
                }
                this.currentlyOpenDropdown = this.valveDropdown.additionalContact ? id : 0;
                this.valveDropdown.opentherm = false;
            }

            zonePosition = this.document.querySelectorAll(".zones-tile")[0].getBoundingClientRect();

            if (zonePosition.bottom > windowHeight - 220) {
                this.valveDropdown.position.bottom = '39px';
                this.valveDropdown.position.top = 'auto';
            } else {
                this.valveDropdown.position.bottom = 'auto';
                this.valveDropdown.position.top = '100%';
            }
        } else {
            zonePosition = id > 0 ? this.document.querySelectorAll(".id" + id)[0].getBoundingClientRect() : 0;
        }

        if (type === 'container-tile') {
            const zonesData = this.database.zones.getValue()

            if ('system' in zonesData) {
                zonesData.system.containersData.forEach((containerData) => {
                    if (containerData && containerData.parameterId === id) {
                        this.valveDropdown.showDropdownInfo = false;
                        this.valveDropdown.opentherm = false;
                        this.valveDropdown.additionalContact = false;

                        this.containerTileDropdown.show = !this.containerTileDropdown.show;
                        this.containerTileDropdown.id = id;
                        if (zonePosition['bottom'] > windowHeight - 220) {
                            this.containerTileDropdown.position.bottom = '39px';
                            this.containerTileDropdown.position.top = 'auto';
                        } else {
                            this.containerTileDropdown.position.bottom = 'auto';
                            this.containerTileDropdown.position.top = '100%';
                        }
                    }
                })
            }
        } else {
            this.containerTileDropdown.show = false;
        }

        const zonesData = this.database.zones.getValue();
        const elements = zonesData['elements'];

        if (Array.isArray(elements)) {
            elements.forEach(val => {
                if (val !== null) {
                    if (val.zone.id === id) {
                        if (type === 'info') {
                            val.showDropdownInfo = !val.showDropdownInfo;
                            val.showDropdownUnderfloor = false;
                            this.valveDropdown.opentherm = false;
                            this.valveDropdown.additionalContact = false;
                        } else if (type === 'underfloor') {
                            val.showDropdownUnderfloor = !val.showDropdownUnderfloor;
                            val.showDropdownInfo = false;
                        }

                        this.currentlyOpenDropdown = val.showDropdownInfo ? id : 0;
                        this.valveDropdown.showDropdownInfo = false;
                        val.zoneStyle = {
                            bottom: '',
                            top: '',
                        };

                        if (zonePosition !== 0 && zonePosition.bottom > windowHeight - 220) {
                            val.zoneStyle.bottom = '39px';
                            val.zoneStyle.top = 'auto';
                        } else {
                            val.zoneStyle.bottom = 'auto';
                            val.zoneStyle.top = '100%';
                        }
                    } else {
                        val.showDropdownInfo = false;
                        val.showDropdownUnderfloor = false;
                    }
                }
            });
        }

        this.zonesSystem.setContainers(id);
    }

    plusVal(value: number): number {
        value = value > 0 ? Math.round(value) : 200;

        return value + 1 <= 350 ? value + 1 : 350;
    }

    minusVal(value: number): number {
        value = value > 0 ? Math.round(value) : 200;

        return value - 1 >= 50 ? value - 1 : 50;
    }

    setTime(value: number): void {
        this.time = {};

        value = value === null
            ? 60
            : value === 0 && this.selectedZone['mode'].mode === 'timeLimit'
                ? 1
                : value;

        this.time.hour = value / 60;
        this.time.hour = Math.floor(this.time.hour);
        this.time.minute = value % 60;
    }

    getTimeLimit(value: number): string {
        let hour = Math.floor(value/60);
        let min = value % 60;

        min = hour === 0 && min === 0 ? 1 : min;

        return (hour > 0 ? hour + ' ' + this.subtitles.setSubtitle(1905) + ' ' : '')
            + min +' '+ this.subtitles.setSubtitle(1907);
    }

    changeHourMinut(type: 'hour' | 'minute', val: number): void {
        let hour = Math.round(this.time.hour);
        let minute = Math.round(this.time.minute);

        if (type === 'hour') {
            hour += val;
        } else if (type === 'minute') {
            minute += val;
        }

        let time = hour * 60 + minute;
        if (time < 1) {
            time = 1;
        } else if (time > 1440) {
            time = 1440;
        }

        this.time.hour = time/60;
        this.time.hour = Math.floor(this.time.hour);
        this.time.minute = time%60;
    }

    onTimeChange(type: 'hour' | 'minute', value: number): void {
        if (type === 'hour') {
            this.time.hour = Number(value);
        } else {
            this.time.minute = Number(value);
        }

        let hour = this.time.hour || 0;
        let minute = this.time.minute || 0;
        let time = hour * 60 + minute;

        if (time < 1) {
            time = 1;
        } else if (time > 1440) {
            time = 1440;
        }

        this.time.hour = Math.floor(time / 60);
        this.time.minute = time % 60;
    }

    setDuringChange(id: number): void {
        if (this.parameters.isZonesSystemControllerType()) {
            this.zonesSystem.containers.forEach(container => {
                container.data.zones.forEach(zone => {
                    if (zone.zone.id === id) {
                        zone.zone.duringChange = true;
                    }
                })
            })
        } else {
            const oldZonesData = this.database.zones.getValue();

            if (Object.keys(oldZonesData).length > 0) {
                const newZonesData = oldZonesData as ZonesData;

                newZonesData.elements.forEach((zone) => {
                    if (id === zone.zone.id) {
                        zone.zone.duringChange = true;
                    }
                });

                this.database.zones.next(newZonesData);
            }
        }
    }

    resetZonesService() {
        this.zonesParameter = {};
    }

    returnValue(changeType: 'constantTemp' | 'timeLimit'): void {
        const data = {
            mode: {
                mode: changeType,
                id: this.selectedZone['mode'].id,
                parentId: this.selectedZone['zone'].id,
                constTempTime: changeType === 'timeLimit'
                    ? (this.time.hour * 60) + this.time.minute
                    : 0,
                setTemperature: this.selectedZone['mode'].setTemperature,
                scheduleIndex: this.selectedZone['mode'].scheduleIndex,
            }
        };

        this.time = {};

        this.http.post(`/api/v1/users/${this.user.user_id}/modules/${this.parameters.selectedModuleHash}/zones`, data)
            .subscribe(() => {
                this.setDuringChange(this.selectedZone['zone'].id);
            });

        this.$state.go('home', {selectedModuleHash: this.parameters.selectedModuleHash});
    }

    signalIcon(componentWithSignal: {
        signalStrength: number
    }, color?: 'white'): string {
        const signalStrength = componentWithSignal.signalStrength;

        switch (true) {
            case signalStrength === -2: // wired signal
                return color ?
                    '/assets/img/zone_icons/cable_' + color + '_48dp.svg' :
                    '/assets/img/zone_icons/cable_black_48dp.svg';
            case signalStrength === -1: // no signal or default value
                return '';
            case signalStrength <= 25:
                return color ?
                    '/assets/img/zone_icons/signal_' + color + '_1_4.svg' :
                    "/assets/img/zone_icons/signal_1_4.svg";
            case signalStrength <= 50:
                return color ?
                    '/assets/img/zone_icons/signal_' + color + '_2_4.svg' :
                    "/assets/img/zone_icons/signal_2_4.svg";
            case signalStrength <= 75:
                return color ?
                    '/assets/img/zone_icons/signal_' + color + '_3_4.svg' :
                    "/assets/img/zone_icons/signal_3_4.svg";
            default:
                return color ?
                    '/assets/img/zone_icons/signal_' + color + '_4_4.svg' :
                    "/assets/img/zone_icons/signal_4_4.svg"
        }
    }

    _selectZone(item: ZoneViewData): void {
        this.selectedZone = _.cloneDeep(item);
    }

    selectContainer(container: SystemContainerView): void {
        this.selectedContainer = container;
    }

    goToZoneInfo(): void{
        this.$state.go('zone', {selectedModuleHash: this.parameters.selectedModuleHash});
        setTimeout(() =>{
            this.$state.go('zone_info', {selectedModuleHash: this.parameters.selectedModuleHash});
        }, 200);
    }

    clearValveDropdown(): void {
        this.valveDropdown = {
            opentherm: false,
            systemTileId: null,
            additionalContact: false,
            position: {
                bottom: '',
                top: '',
            },
            showDropdownInfo: false,
        }
    }

    setTileName(txtId: number, defaultSubtitleId: number) {
        let subtitle = '';
        if (txtId && txtId !== -1) {
            subtitle = this.subtitles.setSubtitle(txtId);
        } else {
            subtitle = this.subtitles.setSubtitle(defaultSubtitleId);
        }
        return subtitle
    }

    goToState(state: string): void {
        this.$state.go(state, {selectedModuleHash: this.parameters.selectedModuleHash});
    }

    goBack(): void {
        window.history.back();
    }


    private subtitle(id: number) {
        return this.subtitles.setSubtitle(id);
    }

    getStateSubtitle(state: ActuatorState): string {
        switch(state) {
            case 'waiting':
                return this.subtitle(3162);
            case 'noCommunication':
                return this.subtitle(1808);
            case 'lowBattery':
                return this.subtitle(2884) + ' - ' + this.subtitle(2885);
            case 'damaged':
                return this.subtitle(2883);
            default: {
                const parsedState = Number.parseInt(state, 10);
                const isNumber = !Number.isNaN(parsedState);
                return isNumber ? state : '';
            }
        }
    }
}
